class MSQCCart {
    constructor(t, e) {
        this.cart = t, this.saved = e, this.actionQueue = [], this.queueProcessing = !1, this.errorLog = []
    }
    returnCart() {
        return this.cart
    }
    fetchCart() {
        // keep the last good cart if cart.json returns an error payload (e.g. rate limit)
        return fetch(window.Shopify.routes.root + "cart.json").then(t => t.json()).then(t => (this.isCart(t) ? (this.cart = t, drawCart(t)) : this.errorLog.push({ action: "fetchCart", ...t }), t)).catch(t => console.error(t))
    }
    clearCart() {
        fetch(window.Shopify.routes.root + "cart/clear.js", {
            method: "POST"
        }).then(t => t.json()).then(t => this.cart = t).catch(t => console.error(t))
    }
    cartTotals() {}
    cartItemVariants() {
        return this.cart.items.map(t => parseInt(t.variant_id))
    }
    showErrorLog() {
        return this.errorLog
    }
    showQueue() {
        return this.actionQueue
    }
    queueStatus() {
        return this.queueProcessing
    }
    addToQueue(t, e, r, i = {}) {
        this.actionQueue.push({
            action: t,
            key: e,
            data: r,
            props: i
        }), this.queueProcessing || this.exeQueute()
    }
    exeQueute() {
        if (this.queueSize()) {
            this.queueProcessing = !0;
            let t = this.actionQueue.shift(),
                {
                    action: e,
                    key: r,
                    data: i,
                    props: s
                } = t;
            let n;
            // a thrown error or unknown action must not leave queueProcessing stuck at true
            try {
                "addToCart" === e ? n = this.addToCart(r, i, s) : "updateItem" === e ? n = this.updateItem(r, i, s) : "updateItemProp" === e ? n = this.updateItemProps(r, i) : "updateCartNote" === e && (n = this.updateCartNote(r, i))
            } catch (o) {
                this.errorLog.push({ action: e, key: r, error: String(o) })
            }
            Promise.resolve(n).then(t => this.rerunQueue(t), () => this.rerunQueue())
        }
    }
    rerunQueue(t) {
        //"bad_request" !== t.status && t.items && t.items.length && (this.cart = t), this.queueSize() ? this.exeQueute() : this.queueProcessing = !1, this.fetchCart()
        this.isCart(t) && (this.cart = t), this.queueSize() ? this.exeQueute() : this.queueProcessing = !1, document.dispatchEvent(new CustomEvent("cart.requestComplete",{detail:this.cart})), this.fetchCart()
    }
    isCart(t) {
        return !!t && "bad_request" !== t.status && Array.isArray(t.items)
    }
    handleCartResponse(t, e = {}) {
        // only replace this.cart with a real cart; error payloads (e.g. 422 out of stock) get logged instead
        return this.isCart(t) ? this.cart = t : this.errorLog.push({ ...e, ...t }), t
    }
    queueSize() {
        return this.actionQueue.length
    }
    clearQueue() {
        this.actionQueue = []
    }
    addToCart(t, e, r = {}) {
        console.log(arguments);
        let i = [];
        i.push({
            id: parseInt(t),
            quantity: parseInt(e),
            properties: r
        });
        let s = {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "xmlhttprequest"
            },
            body: JSON.stringify({
                items: i
            })
        };
        return fetch(window.Shopify.routes.root + "cart/add.js", s).then(t => t.json()).then(e => (200 !== e.status && this.errorLog.push({
            key: t,
            ...e
        }), e)).catch(t => console.error(t))
    }
    updateCartNote(t, e) {
        let r, i = {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "xmlhttprequest"
            },
            body: JSON.stringify(r = "note" === t ? {
                note: e
            } : {
                attributes: e
            })
        };
        return fetch(window.Shopify.routes.root + "cart/update.js", i).then(t => t.json()).then(t => this.handleCartResponse(t, { action: "cartUpdate" })).catch(t => console.error(t))
    }
    updateItem(t, e) {
        let r = {
            updates: {}
        };
        t.forEach(t => {
            r.updates[t] = e
        });
        let i = {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "xmlhttprequest"
            },
            body: JSON.stringify(r)
        };
        return fetch(window.Shopify.routes.root + "cart/update.js", i).then(t => t.json()).then(t => this.handleCartResponse(t, { action: "cartUpdate" })).catch(t => console.error(t))
    }
    getItemProperties(t) {
        let e = this.cart.items.find(e => e.key === t);
        return !!e && !!e.properties && e.properties
    }
    updateItemProps(t, e) {
        let r = this.isCart(this.cart) && this.cart.items.find(e => e.key === t),
            i;
        if (!r) return this.errorLog.push({ action: "updateItemProp", key: t, error: "line item key not found in cart" }), Promise.resolve();
        i = r.quantity;
        let s = {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "xmlhttprequest"
            },
            body: JSON.stringify({
                id: t,
                quantity: i,
                properties: {...r.properties, ...e}
            })
        };
        return fetch(`${window.Shopify.routes.root}cart/change.js`, s).then(t => t.json()).then(e => this.handleCartResponse(e, { action: "updateItemProp", key: t })).catch(t => console.error(t))
    }
    shippingTotal() {
        let t = 0;
        return this.cart.items.forEach(e => {
            e.properties && !e.properties._exclude_free_shipping && (t += e.line_price)
        }), t
    }
    loyaltyPoints() {
        let t = 0;
        return this.cart.item_count && this.cart.items.forEach(e => {
            e.gift_card || "Gift Card" === e.product_type || -1 !== e.sku.toLowerCase().indexOf("blockd") || -1 !== e.sku.toLowerCase().indexOf("sub") ? t += e.final_line_price : e.product_id == DD.product_id && 0 != e.total_discount && (t += e.final_line_price / 2)
        }), parseInt(this.cart.total_price) - parseInt(t)
    }
    hasDailyDeal(t) {
        return this.cart.items.find(e => e.product_id === t)
    }
    hasMaximum(t) {
        let e = this.cart.items.find(e => e.key === t).properties;
        return e.hasOwnProperty("_max_qty") ? parseInt(e._max_qty) : 0
    }
    hasMinimum(t) {
        let e = this.cart.items.find(e => e.key === t).properties;
        return e.hasOwnProperty("_min_purchase") ? parseInt(e._min_purchase) : 0
    }
    itemInCart(t) {
        let e = msqcCart.cart.items.find(e => e.variant_id = t);
        return !!e && e.quantity
    }
}